module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAD1BMVEUAAAA0NDQzMzMzMzMyMjKgRjN5AAAABXRSTlMAQP+/gGkCWzYAAAAsSURBVHicY0AGjMYgYABmqrgAgQKYCSLBxGBhCiOYIjCmoiAQQJhKIABkAgCZlAfcbEXqYAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/mobile.png
// module id = 3JpG
// module chunks = 0